export const GET_LAYERCONFIG = 'GET_LAYERCONFIG'
export const GET_CONFIG = 'GET_CONFIG'
export const GET_LEGEND_SHOW = 'GET_LEGEND_SHOW'
export const GET_SEARCH_PARAMS = 'GET_SEARCH_PARAMS'
export const GET_SEARCH_SHOW = 'GET_SEARCH_SHOW'
export const GET_VISIBLE_LAYERS = 'GET_VISIBLE_LAYERS'
const ALL_GETTERS = {
    GET_LAYERCONFIG, GET_CONFIG, GET_SEARCH_PARAMS, GET_LEGEND_SHOW, GET_SEARCH_SHOW, GET_VISIBLE_LAYERS
}

export default ALL_GETTERS